import React from 'react';
import { motion } from 'framer-motion';
import { Crown, Sparkles } from 'lucide-react';
export function Header() {
  return <motion.header initial={{
    y: -100
  }} animate={{
    y: 0
  }} transition={{
    duration: 0.5
  }} className="fixed top-0 left-0 right-0 z-50 bg-[#1e3a5f] text-white shadow-lg border-b border-[#d4a574]/20" data-id="element-303">
      {/* Desktop Header */}
      <div className="hidden sm:block" data-id="element-304">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-16 flex items-center justify-between" data-id="element-305">
          <div className="flex items-center gap-3" data-id="element-306">
            <div className="flex items-center gap-2" data-id="element-307">
              <Sparkles className="w-4 h-4 text-[#d4a574]" data-id="element-308" />
              <span className="bg-gradient-to-r from-[#d4a574] to-[#c29463] text-white text-xs font-bold px-3 py-1 rounded-full uppercase tracking-wider" data-id="element-309">
                Oferta de Lanzamiento
              </span>
            </div>
            <p className="text-sm font-medium" data-id="element-310">
              Precio especial por tiempo limitado{' '}
              <span className="text-[#d4a574]" data-id="element-311">- ¡Ahorra un 80% hoy!</span>
            </p>
          </div>

          <a href="#oferta" className="group flex items-center gap-2 bg-gradient-to-r from-[#d4a574] to-[#c29463] hover:from-[#c29463] hover:to-[#d4a574] text-[#1e3a5f] font-bold text-sm px-5 py-2.5 rounded-full transition-all hover:scale-105 shadow-lg" data-id="element-312">
            <Crown className="w-4 h-4" data-id="element-313" />
            <span data-id="element-314">Edición Premium</span>
          </a>
        </div>
      </div>

      {/* Mobile Header - Optimized */}
      <div className="sm:hidden" data-id="element-315">
        <div className="px-3 py-2 space-y-2" data-id="element-316">
          {/* Top Row - Badge and Button */}
          <div className="flex items-center justify-between gap-2" data-id="element-317">
            <div className="flex items-center gap-1.5" data-id="element-318">
              <Sparkles className="w-3.5 h-3.5 text-[#d4a574] flex-shrink-0" data-id="element-319" />
              <span className="bg-gradient-to-r from-[#d4a574] to-[#c29463] text-white text-[10px] font-bold px-2 py-0.5 rounded-full uppercase tracking-wider whitespace-nowrap" data-id="element-320">
                Oferta Lanzamiento
              </span>
            </div>

            <a href="#oferta" className="flex items-center gap-1.5 bg-gradient-to-r from-[#d4a574] to-[#c29463] text-[#1e3a5f] font-bold text-xs px-3 py-1.5 rounded-full shadow-md active:scale-95 transition-transform flex-shrink-0" data-id="element-321">
              <Crown className="w-3.5 h-3.5" data-id="element-322" />
              <span data-id="element-323">Premium</span>
            </a>
          </div>

          {/* Bottom Row - Promotional Text */}
          <div className="text-center" data-id="element-324">
            <p className="text-xs font-medium text-gray-200" data-id="element-325">
              Precio especial{' '}
              <span className="text-[#d4a574] font-bold" data-id="element-326">- ¡80% OFF!</span>
            </p>
          </div>
        </div>
      </div>
    </motion.header>;
}